module.exports = __webpack_public_path__ + "img/beauty_blemish-fix.17f45d7.svg";